import { Button, StyledDialogActions } from '../styles';
import { IConfirmDialogActionsProps } from '../types';

export const ConfirmDialogActions = (props: IConfirmDialogActionsProps) => {
  const { closeButton, successButton, onClose, onSuccess, mainColor, confirmLabelDefault, cancelLabelDefault } = props;

  const narrowButtonSymbols = 3;
  const closeButtonLabel = closeButton?.label ?? cancelLabelDefault;
  const successButtonLabel = successButton?.label ?? confirmLabelDefault;
  const minWidth = successButtonLabel.length <= narrowButtonSymbols ? '140px' : '210px';

  return (
    <StyledDialogActions>
      {closeButton !== null && (
        <Button
          onClick={onClose}
          variant='outlined'
          color={closeButton?.color ?? 'inherit'}
          data-testid='confirm-dialog-cancel'
        >
          {closeButtonLabel}
        </Button>
      )}

      {successButton !== null && (
        <Button
          onClick={onSuccess}
          color={successButton?.color ? successButton.color : mainColor.name}
          variant='contained'
          data-testid='confirm-dialog-submit'
          sx={{ minWidth }}
        >
          {successButtonLabel}
        </Button>
      )}
    </StyledDialogActions>
  );
};
